import { render, staticRenderFns } from "./FormeLogo.vue?vue&type=template&id=00ff3291&"
import script from "./FormeLogo.vue?vue&type=script&lang=js&"
export * from "./FormeLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports